import React from 'react'
import { TrialInfoPopover } from 'Components/TrialInfoPopover/TrialInfoPopover'

/**
 * Trigger de Escriba — pill unificada (2026-09-01, pedido de Juan Cruz),
 * mismo shape que Resumen IA/Odontograma/Percentiles (bg blanco, rounded-3,
 * padding 4px — ver PR #325, achicado de 8px por feedback de QA —, ícono
 * "i" de TrialInfoPopover), color de texto propio (#13629b, confirmado
 * contra el Figma real, nodo 3303:270 — coincide con el de Resumen IA,
 * distinto del de Odontograma/Percentiles). Reemplaza el `btn-danger` rojo
 * grande de antes: la "presencia visual FUERTE" (§7.1 del plan original,
 * "el modo de fallo de adopción más común es olvidarse de apretar grabar")
 * era una decisión de producto deliberada, revertida de forma explícita por
 * QA — no un descuido de ese cambio.
 *
 * Anclado al margen inferior derecho de la barra de creación de registros
 * (Form.js) — no a la ventana. Pasa como `trialToolsEnd` de <Form>, que lo
 * envuelve en un `position: absolute` propio (ver Form.js) para no
 * participar del `flex-wrap` de +Evolución/Archivos/etc: dos correcciones
 * de QA sobre el mismo comentario original ("fixear la posición... en el
 * margen derecho inferior") — 2026-09-02 primero probó `position: fixed`
 * contra la VENTANA entera (ese intento, con su guard de colisión contra
 * Room.js en videollamada, se retiró acá mismo), y horas después QA aclaró
 * con el selector exacto del contenedor real que quería decir: el margen
 * inferior derecho DE LA BARRA, no de la pantalla. Este componente en sí no
 * sabe nada de layout — sólo la pill visual (bg blanco, rounded-3, padding
 * 4px — ver PR #325, achicado de 8px por feedback de QA —, ícono "i" de
 * TrialInfoPopover), color de texto propio (#13629b, confirmado contra el
 * Figma real, nodo 3303:270 — coincide con el de Resumen IA, distinto del
 * de Odontograma/Percentiles). Reemplaza el `btn-danger` rojo grande de
 * antes: la "presencia visual FUERTE" (§7.1 del plan original, "el modo de
 * fallo de adopción más común es olvidarse de apretar grabar") era una
 * decisión de producto deliberada, revertida de forma explícita por QA — no
 * un descuido de ese cambio.
 */
const EscribaButton = ({ onClick, recording, locked, feedbackRef, t = (k, d) => d }) => (
  <div
    className="d-flex align-items-center gap-1 rounded-3 bg-white shadow"
    style={{ padding: 4 }}
  >
    <button
      type="button"
      data-testid="escriba-open-button"
      className="d-flex align-items-center btn p-0 border-0 font-nunito gap-2"
      // `locked` = T&C de IA sin aceptar: se atenúa como el resto de las trial
      // tools (Resumen HCE/Odontograma/Percentiles). El onClick sigue vivo (lo
      // maneja EHR: abre el modal de T&C en vez de la feature).
      style={{ color: '#13629b', opacity: locked ? 0.5 : 1 }}
      onClick={onClick}
      disabled={recording}
    >
      🎙 {t('ehr:escriba_button', 'Grabar consulta')}
    </button>
    <TrialInfoPopover
      title={t('ehr:escriba_feature_name', 'Grabar consulta')}
      description={t('ehr:escriba_trial_description', 'Grabá el audio de la consulta y transcribilo automáticamente a la evolución del paciente. Sin tipear, sin perder el hilo de la consulta.')}
      onLeaveReview={() => feedbackRef?.current?.openManual()}
    />
  </div>
)

export default EscribaButton
